export default "__VITE_ASSET__DevkmmgP__"